import React, { useState, useEffect, useRef ,useContext} from "react";

import * as Yup from "yup";
import Select from "react-select";
import { Steps,Modal } from "antd";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Axios from "../../Helpers/Interceptors";
import { Formik, Form, Field, ErrorMessage ,useFormikContext } from "formik";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Polyline,
  StreetViewPanorama,
} from "@react-google-maps/api";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
// Sample data: Request type, estimated vs actual resolution times (in hours)
import "./DepartMentTicketDetail.scss";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import { UserInfo } from "../../Context/userInfo";

import { getRole } from "../../Helpers/utils";
import image from "../../assests/Screenshot 2025-03-07 181628.png";
import image1 from "../../assests/MAII_Backgrounds_hexagonal-wave.webp";
const containerStyle = {
  width: "100%",
  height: "15rem",
};

const formatDateUS = (date) => {
  return new Date(date).toLocaleDateString("en-US");
};
export default function DepartMentTicketDetail() {
  const [confirmLogsModal, setconfirmLogsModal] = useState(false);


  const [stepStatus, setstepStatus] = useState("Reported");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const steps = [
    { title: "Reported" },
    { title: "In Progress" },
    { title: "Assign To DPT" },
    { title: "Resolved" },
  ];
  const [agentList, setAgentList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const extractInteger = (percentageStr) => {
    const number = parseFloat(percentageStr); // Convert string to number
    return Math.floor(number); // Return integer part
  };

  const navigate = useNavigate();
  const [streetViewVisible, setStreetViewVisible] = useState(false);
  const [initialValues, setInitialValues] = useState({
    request_type: "",
    request_subtype: "",
    name: "",
    contact_phone: "",
    contactEmail: "",
    status: "",
    priority: "",
    description: "",
    ticketNumber: "",
    agentId: "",
    departmentId: "",
    comment:""
  });

  const validationSchema = Yup.object().shape({
    request_type: Yup.string(),
    //   .required("Role is required *"),
    request_subtype: Yup.string(),
    //   .required("Role is required *"),
    name: Yup.string(),
    // .required("Role is required *"),
    contact_phone: Yup.string(),
    //   .required("Role is required *"),
    contactEmail: Yup.string(),
    //   .required("Role is required *"),
    status: Yup.string(),
    //   .required("Role is required *"),
    priority: Yup.string(),
    //   .required("Role is required *"),
    description: Yup.string(),
    //   .required("Role is required *"),
    ticketNumber: Yup.string(),
    //   .required("Role is required *"),
  });
  const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const { id } = useParams();
  const [data, setData] = useState({});
  const [logList, setLoglist] = useState([]);

  const [center, setcenter] = useState({ lat: 39.5, lng: -98.35 });

  const { userData, updateUserData } = useContext(UserInfo);
  const [roles, setRoles] = useState(null);

  useEffect(() => {
    if (userData) {
      setRoles(getRole(userData.data?.userInfo?.roles));
    }
  }, [userData]);

  useEffect(() => {
    getAgents();
    getDepartments();
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await Axios.get(
        `https://demo.tscti.com/api/status-history/ticketnumber/${id}`
      );

      console.log(response.data);

      setData(response.data.incident);

      setLoglist(
        response.data.statusHistories.map((res) => {
          return {
            title: res.status,
            description: `${res.description} ${formatDateUS(res.createdAt)}`,
          };
        })
      );

      let data = response.data.incident;
      setcenter({
        lat: data["location"]["coordinates"][0],
        lng: data["location"]["coordinates"][1],
      }); // Approximate center of the U.S.

      setInitialValues({
        request_type: data.request_type,
        request_subtype: data.request_subtype,
        name: data.reporter.name,
        contact_phone: data.reporter.contact_phone,
        contactEmail: data.reporter.contactEmail,
        status: data.status == "Request Created" ? "Reported" : data.status,
        priority: data.priority,
        description: data.description,
        ticketNumber: data.ticketNumber,
        address: data.location.address,
        agentId:data.agentId,
        departmentId:data.departmentId,
      });
      setstepStatus(
        data.status == "Request Created" ? "Reported" : data.status
      ); // Dynamic value from your state or API

      fetchMuitiQuery(data);

      fetchClass(data);

      fetchSimilarImage(data);
      fetchPredictImage(data);
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

  const getAgents = async () => {
    try {
      const response = await Axios.get(
        `https://demo.tscti.com/api/agents/agents-list`
      );
      console.log("jj", response.data);

      setAgentList(response.data);
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

  const getDepartments = async () => {
    try {
      const response = await Axios.get(
        `https://demo.tscti.com/api/departments/departments-list`
      );

      setDepartmentList(response.data);
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

  const [multiQuery, setmultiQuery] = useState([]);
  const [multiClass, setmultiClass] = useState([]);

  async function convertImageToBase64(imageUrl) {
    const response = await fetch(imageUrl);
    const arrayBuffer = await response.arrayBuffer();
    const base64String = btoa(
      String.fromCharCode(...new Uint8Array(arrayBuffer))
    );
    console.log(base64String);
    return base64String;
  }

  const fetchMuitiQuery = async (data) => {
    try {
      const response = await Axios.post(`https://smartml.tscti.com/classify/`, {
        text: data.description,
      });
      console.log(response.data);

      setmultiQuery([
        { data: response.data.request_type, heading: "Request Type" },
        { data: response.data.responsible_agency, heading: "Request Type" },
        { data: response.data.request_reason, heading: "Request Reason" },
        { data: response.data.confidence, heading: "Confidence" },
      ]);
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };
  const fetchClass = async (data) => {
    try {
      const response = await Axios.post(
        `https://smartml.tscti.com/classify/multiple/`,
        { texts: [data.description] }
      );
      console.log(response.data.issues[0].classifications);
      setmultiClass(response.data.issues[0].classifications);
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };
  const [predict, setpredict] = useState([]);
  const fetchSimilarImage = async (data) => {
    // const urlArray = data.attachment.map(item => item.url);
    // try {
    //   const response = await Axios.post(
    //     `https://smartml.tscti.com/find_similar`,
    //     { file: file }
    //   );
    // } catch (err) {
    //   console.log(err.message);
    // } finally {
    //   console.log(false);
    // }
  };


  const cancelToggleLogs = () => {

    setconfirmLogsModal(false);

  };

  const fetchPredictImage = async (data) => {
    const urlArray = data.attachment.map((item) => item.url);
    try {
      const response = await Axios.post(
        `https://smartml.tscti.com/predict_image/`,
        { image_paths: urlArray }
      );

      setpredict(response.data.results);
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

  const nightModeStyles = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
  ];
  const mapOptions = {
    styles: nightModeStyles,
    disableDefaultUI: false,
    zoomControl: true,
  };

  const submit = async (value, reset) => {
    try {
      const obj = {
        ...value,

      };
      if(value.comment){
        obj.comment = [
          {
            description: value.comment,
            author: roles,
          },
        ]
      }
      const response = await Axios.put(
        `https://demo.tscti.com/api/incident/${data.id}`,
        obj
      );

      if (response.status == 200) {
        // Checks if status code is 200 (OK)
        toast.success("Status change successfully");

        save(value,reset)

      }
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };



  const save = async (value,reset) => {
    try {
      const obj = {

          "ticketHistoryId":value.ticketNumber,
          "status":value.status,
          "description":value.description


      };

      const response = await Axios.post(
        `https://demo.tscti.com/api/status-history`,
        obj
      );

      if (response.status == 200) {

        toast.success("Status change successfully");
        reset();
        setInitialValues(prev => ({ ...prev, comment: "" }));
        fetchData();
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };


  const currentStepIndex = steps.findIndex((step) => step.title === stepStatus);

  const [isDivVisible, setIsDivVisible] = useState(false);

  const generatePDF = () => {
    // Toggle the div visibility to show it for PDF generation
    setIsDivVisible(true);

    // Get the HTML content of the div with id 'download-template'
    const content = document.getElementById("download-template");

    // Use html2pdf.js to generate the PDF from HTML content
    const options = {
      margin: 1,
      filename: "ticket-details.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a3", orientation: "portrait", fontSize: 5 },
    };

    // Generate PDF
    html2pdf()
      .from(content) // Pass the content you want to convert to PDF
      .set(options)
      .save() // Automatically download the PDF
      .finally(() => {
        // Hide the div after PDF generation
        setIsDivVisible(false);
      });
  };




  const confirmToggle = async (values) => {
    console.log(values)
    try {


        const obj = {

          "ticketId": data?.id

        };

        if(roles == 'Admin'){
          obj.agentId = values?.agentId

          const  response = await Axios.post(
            `https://demo.tscti.com/api/agents/assign-ticket`,
             obj
          );
          if (response.status == 200) {
            // Checks if status code is 200 (OK)

            toast.success("Status change successfully");
            getAgents();
            getDepartments();
            fetchData();


            setConfirmModalOpen(false);

          }

        }else{
          obj.departmentId = values?.departmentId

           const  response1 = await Axios.post(
          `https://demo.tscti.com/api/departments/assign-ticket`,
           obj
        );
        if (response1.status == 200) {
          // Checks if status code is 200 (OK)

          toast.success("Status change successfully");
          getAgents();
          getDepartments();
          fetchData();


          setConfirmModalOpen(false);

        }

        }
        console.log(obj)



    } catch (err) {
      console.log(err);
    } finally {
      console.log(false);
    }

  };




  const cancelToggle = (setfield) => {

    if(roles == 'Admin'){
      setfield('agentId', data.agentId);
      setConfirmModalOpen(false);
    }else{
      setfield('departmentId', data.departmentId);
      setConfirmModalOpen(false);
    }


  };



  const handleDropdownChange = () => {

    setConfirmModalOpen(true);
  };
  return (
    <>
      <div className="container-fluid">
        <div
          className="card  card-margin  p-2"
          style={{
            background: "rgb(21 33 45)",
            textAlign: "center",
          }}
        >
          <h5 style={{ color: "whitesmoke" }}>
            {" "}
            311 Service Ticket No #{data.ticketNumber}
          </h5>
        </div>


        <div className="row">
          <div className="col-md-6 col-lg-6">
            <div
              className="card card-size" style={{background:'#e5e7eb'}}

            >
              <Formik
                // validationSchema={validationSchema}
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={(values, { resetForm }) => {
                  submit(values, resetForm); // Use your custom submit logic here
                }}
              >
                {({ errors, touched, setFieldValue,values }) => (
                  <Form id="signup-form" className="signup-form set-content">
                    <div className="row">
                      <div className="heading-content p-1">
                        <h5>Tickets Detail</h5>
                      </div>
                      <div className="col-md-4 col-lg-4 set-content">
                        <label style={{color:'black'}} className="label-heading2 status-mode">Ticket Number</label>
                        <Field
                          className={`form-input1 ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="ticketNumber"
                          id="ticketNumber"
                          placeholder="Ticket Number*"
                          autoComplete="new-password"
                        />
                      </div>
                      <div className="col-md-4 col-lg-4 set-content">
                        <label style={{color:'black'}} className="label-heading2 status-mode">Ticket Type</label>
                        <Field
                          className={`form-input1 ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="request_type"
                          id="request_type"
                          placeholder="Ticket Type*"
                          autoComplete="new-password"
                        />
                      </div>
                      <div className="col-md-4 col-lg-4 set-content">
                        <label style={{color:'black'}} className="label-heading2 status-mode">
                          Ticket Sub Type
                        </label>
                        <Field
                          className={`form-input1 ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="request_subtype"
                          id="request_subtype"
                          placeholder="Ticket Sub Type*"
                          autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-4 col-lg-4 set-content">
                        <label style={{color:'black'}} className="label-heading2 status-mode">Priority</label>
                        <Field
                          className={`form-input1 ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="priority"
                          id="priority"
                          placeholder="Priority*"
                          autoComplete="new-password"
                        />
                      </div>
                    { roles == 'Admin' && <div className="col-md-4 col-lg-4 set-content">
                        <label style={{color:'black'}} className="label-heading2 status-mode">
                          Assign To Agent
                        </label>
                        <Field name="agentId">
                          {({ form }) => {
                            const selectedValue = agentList.find(
                              (option) => option.agentId === form.values.agentId
                            );

                            return (
                              <Select
                                value={
                                  selectedValue
                                    ? {
                                        value: selectedValue.agentId,
                                        label: selectedValue.agentUserName,
                                      }
                                    : null
                                }
                                options={agentList.map((res) => ({
                                  value: res.agentId,
                                  label: res.agentUserName,
                                }))}
                                isSearchable
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    width: "100%",
                                    height: 48,
                                    background: "#15212d",
                                    borderColor: "rgb(223, 223, 223)",
                                  }),
                                }}
                                onChange={(selectedOption) => {
                                  handleDropdownChange()

                                  form.setFieldValue(
                                    "agentId",
                                    selectedOption?.value || ""
                                  );
                                }}
                              />
                            );
                          }}
                        </Field>
                      </div>}
                      {roles == 'Agent' &&
                        <div className="col-md-4 col-lg-4 set-content">
                          <label style={{color:'black'}} className="label-heading2 status-mode">
                            Assign to Department
                          </label>
                          <Field name="departmentId">
                            {({ form }) => {
                              const options = departmentList.map((res) => ({
                                value: res.agentId,
                                label: res.agentUserName,
                              }));

                              const selectedValue = options.find(
                                (d) => d.value === form.values.departmentId
                              );

                              return (
                                <Select
                                  value={selectedValue || null}
                                  options={options}
                                  isSearchable
                                  isDisabled={!form.values.agentId && !form.values.departmentId}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      width: "100%",
                                      height: 48,
                                      background: "#15212d",
                                      borderColor: "rgb(223, 223, 223)",
                                    }),
                                  }}
                                  onChange={(selectedOption) => {
                                    handleDropdownChange()
                                    form.setFieldValue(
                                      "departmentId",
                                      selectedOption?.value || ""
                                    );
                                  }}
                                />



                              );






                            }}




                          </Field>
                        </div>
                      }
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-4 col-lg-4 set-content">
                        <label style={{color:'black'}} className="label-heading2">Status</label>
                        <Field name="status" >

                          {({ form }) => {

                            const options = [
                              { value: "Reported", label: "Reported", isDisabled: true  },
                              { value: "In Progress", label: "In Progress" , isDisabled: true },
                              {
                                value: "Assign To DPT",
                                label: "Assign to DPT",isDisabled: true
                              },
                              { value: "Resolved", label: "Resolved" },
                            ];

                            const selectedValue = options.find(
                              (opt) => opt.value === form.values.status
                            );

                            return (
                              <Select
                                value={selectedValue || null}
                                options={options}
                                isSearchable
                                className="status-mode"

                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    width: "100%",
                                    height: 48,
                                    // background: "#15212d",
                                    borderColor: "rgb(223, 223, 223)",
                                  }),
                                }}
                                onChange={(selectedOption) => {
                                  form.setFieldValue(
                                    "status",
                                    selectedOption?.value || ""
                                  );
                                }}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="heading-content p-1">
                        <h5>Reporter Details</h5>
                      </div>
                      <div className="col-md-4 col-lg-4 set-content">
                        <label style={{color:'black'}} className="label-heading2 status-mode">Name</label>
                        <Field
                          className={`form-input1 ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="name"
                          id="name"
                          placeholder="Name*"
                          autoComplete="new-password"
                        />
                      </div>
                      <div className="col-md-4 col-lg-4 set-content">
                        <label style={{color:'black'}} className="label-heading2 status-mode">Phone No</label>
                        <Field
                          className={`form-input1 ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="contact_phone"
                          id="contact_phone"
                          placeholder="Phone No*"
                          autoComplete="new-password"
                        />
                      </div>
                      <div className="col-md-4 col-lg-4 set-content">
                        <label style={{color:'black'}} className="label-heading2 status-mode">Contact Email</label>
                        <Field
                          className={`form-input1 ${
                            errors.email && touched.email ? "error" : ""
                          }`}
                          name="contactEmail"
                          id="contactEmail"
                          placeholder="Email*"
                          autoComplete="new-password"
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="form-group">
                        <div className="col-md-6 col-lg-6">
                          <label style={{color:'black'}} className="label-heading2 status-mode">Description</label>
                          <Field
                            as="textarea"
                            className={`form-input1 ${
                              errors.email && touched.email ? "error" : ""
                            }`}
                            name="description"
                            id="description"
                            placeholder="Description*"
                            autoComplete="new-password"
                            rows="4"
                            cols="12"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-1">
                      <div className="form-group">
                        <div className="col-md-12 col-lg-12">
                          <label style={{color:'black'}} className="label-heading2">Comment</label>
                          <Field
                            as="textarea"
                            className={"form-input1"}
                            name="comment"
                            id="comment"
                            placeholder="Comment*"
                            autoComplete="new-password"
                            rows="4"
                            cols="20"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                      }}
                    >
                       <button
                        className="btn btn-style  btn-primary"
                        onClick={() => setconfirmLogsModal(true)}
                        type="button"
                      >
                        <i
                          className="bx bx-show"
                          style={{ marginRight: "8px" }}
                        ></i>{" "}
                        View Logs
                      </button>
                      <button
                        className="btn btn-style  btn-save1"
                        style={{
                          background: "#0e2b4e",
                          color: "whitesmoke",
                        }}
                      >
                        <i
                          className="fas fa-save"
                          style={{ marginRight: "8px" }}
                        ></i>{" "}
                        Save
                      </button>

                      <button
                        className="btn btn-style  btn-cancel"
                        onClick={() => navigate("/dashboard")}
                        style={{ background: "#F44336", color: "whitesmoke" }}
                      >
                        <i
                          className="fas fa-times"
                          style={{ marginRight: "8px" }}
                        ></i>{" "}
                        Cancel
                      </button>
                    </div>



                    <Modal
                              open={confirmModalOpen}
                              onCancel={() => cancelToggle(setFieldValue)}
                              destroyOnClose={true}
                              footer={null}
                              maskClosable={false}
                            >
                              <div className="signup-content-model1">
                                <p>
                                  Are you sure you want to Assign this {roles == 'Admin' ? 'Agent ' : 'Department'}  ?
                                </p>
                                <div className="submit-container1" style={{ marginTop: "20px" }}>
                                  <button
                                    className="submit-button1 "
                                    type="submit"
                                    onClick={()=> confirmToggle(values)}
                                  >
                                    Yes
                                  </button>
                                  <button
                                    className="submit-button2"
                                    type="button"
                                    onClick={() => cancelToggle(setFieldValue)}
                                  >
                                    No
                                  </button>
                                </div>
                              </div>
                            </Modal>
                  </Form>
                )}
              </Formik>
            </div>

          </div>
          <div className="col-md-6 col-lg-6 ">


            <div
                className="card  card-size "
                style={{
                  background: "#e5e7eb",
                  border: "0px",
                  overflowX: "hidden",
                  height:'98%'

                }}
              >
                <div
                className="attachment1 p-3 mb-3"
                style={{ background: "#e5e7eb" }}
              >
                <div className="heading-content p-1">
                  <h5>Attachments</h5>
                </div>
                <div className="image-box">
                  <div className="row">
                    {data.attachment?.length > 0 &&
                      data.attachment.map((res, index) => (
                        <div className="col-md-6">
                          {" "}
                          <a
                            key={index}
                            href={res.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ width: "50%" }} // Each image container takes 35% of the parent width
                          >
                            <img
                              src={res.url}
                              style={{
                                width: "100%", // Makes image fill 35% of the parent container
                                aspectRatio: "1/1", // Ensures a square shape
                                objectFit: "fill", // Crops image to fit without distortion
                                borderRadius: "5px", // Optional: rounded corners
                              }}
                              alt="Attachment"
                            />
                          </a>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
                <div
                  className="attachment1 p-3"
                  style={{ background: "#e5e7eb" }}
                >




                  <div className="heading-content p-1">
                <h5>Logs History</h5>
              </div>
              <Steps
                className="light-mode"
                progressDot
                direction="vertical"
                items={logList}
              />
                </div>
              </div>
          </div>





</div>










      </div>

      <Modal
  open={confirmLogsModal}
  onCancel={cancelToggleLogs}
  destroyOnClose={true}
  footer={null}
  maskClosable={false}
>
  <div className="signup-content-model1">
    <h5 style={{ marginBottom: "10px", fontWeight: 600, fontSize: "18px" }}>
      📝 Comments History
    </h5>

    {/* Scrollable container */}
    <div
      style={{
        maxHeight: "300px",
        overflowY: "auto",
        padding: "10px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        border: "1px solid #dee2e6",
      }}
    >
      {data.comment?.length > 0 ? (
        data.comment.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              marginBottom: "15px",
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              padding: "10px",
              alignItems: "flex-start",
            }}
          >
            {/* Avatar / Initials */}
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#007bff",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: "14px",
                marginRight: "10px",
              }}
            >
              {item.author?.charAt(0).toUpperCase()}
            </div>

            {/* Comment Body */}
            <div>
              <p style={{ margin: 0, fontWeight: "600", color: "#343a40" }}>
                {item.author}
              </p>
              <p style={{ margin: "5px 0 0", color: "#495057" }}>
                {item.description}
              </p>
            </div>
          </div>
        ))
      ) : (
        <p style={{ color: "#888", textAlign: "center" }}>No comments available</p>
      )}
    </div>

    <div className="submit-container1" style={{ marginTop: "20px", textAlign: "right" }}>
      <button
        className="submit-button2"
        type="button"
        onClick={cancelToggleLogs}
        style={{
          backgroundColor: "#dc3545",
          color: "#fff",
          border: "none",
          padding: "8px 16px",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Close
      </button>
    </div>
  </div>
</Modal>


    </>
  );
}
